<!--
 * @Author: vince
 * @Date: 2021-08-16 14:11:01
 * @LastEditors: vince
 * @LastEditTime: 2021-09-06 14:42:14
 * @Description: 
-->
<template>
	<div>
		<div class="filter-bar mb-sm">
			<el-button slot="reference" size="small" @click="$router.go(-1)">返回</el-button>
		</div>
		<div v-loading="loading" class="content-box">
			<div class="detail-main mb-2px">
				<div class="title">{{detail.title}}</div>
				<div class="classfiy">
					{{detail.gradeName}}{{detail.term==1?"上":"下"}}
					<span>></span>
					{{detail.disciplineName}}
				</div>
				<div class="uv">
					<span class="pubdate">{{detail.createTime}}</span>
					<span>
						<i class="el-icon-view"></i>
						{{detail.browseCount}}
					</span>
					<span>
						<i class="el-icon-download"></i>
						{{detail.downloadCount}}
					</span>
					<span>
						<i class="el-icon-star-off"></i>
						{{detail.collectCount}}
					</span>
				</div>
				<div class="uv">
					<span class="pubdate pubdate-link" @click="externalUrl(detail.link)">外链: <i>{{detail.link}}</i></span>
				</div>
			</div>
			<div class="detail-oprate mb-md">
				<div class="avatar">
					<i class="el-icon-s-custom"></i>
				</div>
				<div class="main">
					<div class="tname">{{detail.userName}}</div>
					<div class="tschool">{{detail.schoolName}}</div>
				</div>
				<div class="btns">
					<el-button v-if="userInfo.roleCodes.includes('admin') || userInfo.userId==detail.createBy"  type="primary" size="small" icon="el-icon-edit" @click="$router.push({name:'demonstrationRadiationEdit',params:id})">编辑</el-button>
					<el-popconfirm v-if="userInfo.roleCodes.includes('admin') || userInfo.userId==detail.createBy"  class="mx-md" title="确定要删除？" @confirm="onDelete">
						<el-button slot="reference" type="danger" size="small" icon="el-icon-delete">删除</el-button>
					</el-popconfirm>
					<el-button :class="detail.isCollect ? '':'collection'" :icon="detail.isCollect?'el-icon-star-off':'el-icon-star-on'" size="small" @click="onCollection">{{detail.isCollect?"收藏":"取消收藏"}}</el-button>
					<el-button icon="el-icon-share" size="small" @click="showJoinPop = true">分享</el-button>
					<el-button icon="el-icon-download" size="small" @click="downZip">下载</el-button>
				</div>
			</div>
			<div class="detail-file mb-md" v-if="detail.radiationAttachDTOS&&detail.radiationAttachDTOS.length>0">
				<div class="sec-title">
					<div class="title">资源文件</div>
				</div>
				<div class="file-item" v-for="(item,index) in detail.radiationAttachDTOS" :key="index">
					<div class="icon">
						<i :class="mapFileIcon(item.attachType)"></i>
					</div>
					<div class="main">
						<div class="name">{{item.attachName||item.attachUrl}}</div>
						<div class="size">{{item.attachType}}文件 {{item.attachSize*1024|fileSizeFilter}}</div>
					</div>
					<div class="oprate">
						<el-button icon="el-icon-search" type="primary" size="small" plain @click="lookFile(item.attachUrl)">预览</el-button>
						<el-button icon="el-icon-download" type="primary" size="small" @click="downloadFile(item.attachUrl,item.attachName)">下载</el-button>
					</div>
				</div>
			</div>
			<div class="detail-article">
				<div class="sec-title">
					<div class="title">文章内容</div>
				</div>
				<div class="bg-white pa-md" v-html="detail.summary"></div>
			</div>
		</div>
		<join-pop @close="showJoinPop = false" @joinUsersChange="joinUserChange" :showJoinPop="showJoinPop" v-if="showJoinPop"></join-pop>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { postJson, postData, downloadZip } from "../../http/fetch";
import JoinPop from "@/components/common/JoinPop.vue";
import {
	mapFileIcon,
	lookFile,
	fileSizeFilter,
	downloadUrlFile
} from "../../utils/index";
export default {
	name: "demonstrationRadiationDetail",
	props: {
		id: {
			require: true,
			type: String | Number
		}
	},
	components: {
		JoinPop
	},
	data() {
		return {
			showJoinPop: false,
			loading: false,
			detail: {}
		};
	},
	filters: {
		fileSizeFilter
	},
	created() {
		this.getData();
	},
	computed: {
		...mapState(["userInfo"]),
		...mapGetters(["schoolCode", "operatorId"])
	},
	mounted() {},
	methods: {
		mapFileIcon,
		lookFile,
		externalUrl(link){
			window.open(link)
		},
		downZip() {
			let urls = this.detail.attach
				? this.detail.attach.map(m => m.attachUrl)
				: [];
			if (urls.length == 0 && this.detail.summary.length == 0) {
				this.$message.warning("暂无文件可以下载！");
				return;
			}
			downloadZip(
				{ fileName: this.detail.title, html: this.detail.summary },
				urls,
				this.detail.title
			).then(() => {
				//保存下载记录
				postJson("/operator/saveDownloadInfo", {
					infoCode: this.detail.infoCode,
					module: "radiation",
					operatorId: this.userInfo.userId,
					schoolCode: this.userInfo.schoolCode
				});
			});
		},
		downloadFile(url, name) {
			//确认下载完成 后 进行下载记录保存
			downloadUrlFile(url, name);
			//保存下载记录
			postJson("/operator/saveDownloadInfo", {
				infoCode: this.detail.infoCode,
				module: "radiation",
				operatorId: this.userInfo.userId,
				schoolCode: this.userInfo.schoolCode
			});
		},
		onDelete() {
			this.loading = true;
			postData("/teacherRadiationInfo/removeTeacherRadiationIfo", {
				id: this.id,
				operatorId: this.operatorId
			})
				.then(res => {
					this.loading = false;
					this.$router.push({ name: "demonstrationRadiation" });
					this.$message.success("删除成功！");
				})
				.catch(e => {
					this.loading = false;
					this.$message.error("删除失败，请稍后重试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getData() {
			this.loading = true;
			postData("/teacherRadiationInfo/getTeacherRadiation", {
				id: this.id,
				operatorId: this.operatorId
			})
				.then(res => {
					this.detail = res;
				})
				.catch(e => {})
				.finally(() => {
					this.loading = false;
				});
		},
		onCollection() {
			postJson("/collectInfo/saveCollect", {
				infoCode: this.detail.infoCode,
				module: "radiation",
				operatorId: this.userInfo.userId,
				schoolCode: this.userInfo.schoolCode
			}).then(res => {
				this.getData();
			});
		},
		joinUserChange(users) {
			postJson("/share/shareInfo", {
				infoCode: this.detail.infoCode,
				module: "radiation",
				operatorId: this.userInfo.userId,
				schoolCode: this.userInfo.schoolCode,
				teacherIds: users.map(i => i.userId)
			})
				.then(res => {
					this.$message.success("分享成功！");
				})
				.catch(err => {
					this.$message.error("分享失败，请稍后重试！");
					console.log("err", err);
				})
				.finally(() => {
					this.showJoinPop = false;
					console.log("finally");
				});
		}
	}
};
</script>

<style>
</style>
